/**
 * 0-instock.js (ヘッダーセクション設定同期版・Fabric 4.1.3 競合対策済)
 * section.settings.instock が TRUE の時だけ、自動絞り込みを実行します。
 */
(() => {
  if (window.__instockFilterLoaded) return;
  window.__instockFilterLoaded = true;

  const EXCLUDE_KEYWORDS = ['archives', 'soldout', 'sold-out', 'outlet'];
  let lastProcessedPath = '';
  let isManuallyCleared = false;

  const runInstockFilter = () => {
    const currentPath = window.location.pathname.toLowerCase();
    const currentSearch = window.location.search;

    // 1. 静的・軽量な条件チェック
    if (!currentPath.includes('/collections/')) return;
    if (EXCLUDE_KEYWORDS.some(keyword => currentPath.includes(keyword))) return;

    // ★【Fabric対策①】URLに page= が含まれる（2ページ目以降）時は、絶対に自動チェックを入れない
    if (currentSearch.includes('page=')) return;

    // ★【Fabric対策②】URLに他のフィルターやソートが入っているが、instockがない＝ユーザーが意図的に操作した後
    //（※1ページ目で他の条件を選んだ際、勝手にinstockがONに戻るのを防ぐ）
    if (currentSearch.length > 0 && !currentSearch.includes('filter.p.m.custom.instock')) {
      isManuallyCleared = true;
    }

    // 2. メニュー移動（Ajax遷移）の検知とリセット
    if (lastProcessedPath !== currentPath) {
      lastProcessedPath = currentPath;
      isManuallyCleared = false;
    }
    if (isManuallyCleared) return;

    // 3. ヘッダーセクション判定
    if (document.querySelector('.js-header-instock-false') || !document.querySelector('.js-header-instock-true')) {
      return;
    }

    // 4. ページ内にある「在庫あり」チェックボックスを探索
    const instockCheckbox = document.querySelector(
      'input[type="checkbox"][value="1"][name*="instock"], ' +
      'input[type="checkbox"][name*="v.p.m.custom.instock"], ' +
      'input[type="checkbox"][value="1"]'
    );

    if (!instockCheckbox) return;

    // 5. 【自動クリックの実行】
    if (!currentSearch.includes('filter.p.m.custom.instock') && !instockCheckbox.checked) {
      requestAnimationFrame(() => {
        // 直前で条件が変わっていないか最終確認
        if (!instockCheckbox.checked && !window.location.search.includes('filter.p.m.custom.instock')) {
          instockCheckbox.checked = true;
          instockCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
          isManuallyCleared = true;
        }
      });
    }
  };

  // --- ページ遷移とイベントのハンドリング ---

  // A. 初回実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInstockFilter);
  } else {
    runInstockFilter();
  }

  // B. ブラウザの戻る・進むを検知
  window.addEventListener('popstate', runInstockFilter);

  // C. FabricテーマのAjax（History API / pushState）によるURL書き換えをキャッチ
  const originalPushState = history.pushState;
  history.pushState = function(...args) {
    originalPushState.apply(this, args);
    // URLが書き換わった直後、一瞬だけ待って判定（ページネーション競合を回避）
    setTimeout(runInstockFilter, 60);
  };

  // D. ユーザーの手動操作（チェック外し / 他のフィルター操作）を即座にロック
  document.addEventListener('change', (e) => {
    if (!e.target) return;
    
    // 在庫チェックボックス自体が操作された場合
    if (e.target.matches('input[type="checkbox"]')) {
      const name = e.target.name || '';
      const value = e.target.value || '';
      if (name.includes('instock') || name.includes('v.p.m.custom.instock') || value === '1') {
        if (!e.target.checked) {
          isManuallyCleared = true; // 手動で外されたらロック
        }
        return;
      }
    }

    // Fabricテーマ内の「他のフィルター」や「並び替え（select）」が動いた場合
    // 自動チェックが暴発してページ遷移を壊さないよう、手動クリア扱いにして保護する
    isManuallyCleared = true;
  }, { passive: true });
})();

/**
 * Fabricテーマ専用：言語・通貨セレクターのSEO隠蔽＆動的復元スクリプト
 * クローラーに国名・言語のノイズテキストを一切読ませず、人間にだけ瞬間的に描画します。
 */
(() => {
  const mountLocalization = () => {
    // 画面内に存在するすべてのセレクターコンテナを取得（ヘッダーとフッター両方に対応）
    const containers = document.querySelectorAll('.js-seo-hidden-localization');

    containers.forEach(container => {
      const template = container.querySelector('.js-localization-template');
      if (!template) return; // すでに復元済みの場合はスキップ

      // template内のHTMLを安全に複製
      const clone = template.content.cloneNode(true);
      
      // 元の場所に流し込んで表示させる
      container.appendChild(clone);

      // テーマ側のカスタム要素（Web Components）に正しく初期化命令を飛ばす
      const customElement = container.querySelector('localization-form-component');
      if (customElement && typeof customElement.connectedCallback === 'function') {
        customElement.connectedCallback();
      }

      // クローラー除外完了のためtemplateタグは完全に削除
      template.remove();
    });
  };

  // 1. ページ読み込み時の最速のタイミングで復元
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountLocalization);
  } else {
    mountLocalization();
  }

  // 2. FabricテーマのAjax遷移（コレクションのページ切り替えやソート）時にも追従
  const originalPushState = history.pushState;
  history.pushState = function(...args) {
    originalPushState.apply(this, args);
    setTimeout(mountLocalization, 50);
  };
  window.addEventListener('popstate', mountLocalization);
})();
